<template>
    <div class="d-flex flex-row justify-content-between">
        <span class="sub-title" v-text="title"></span>
        <span v-if="!isFree" class="price" v-text="formattedPrice"></span>
        <span v-else class="price green">Gratis</span>
    </div>
</template>

<script>
  export default {
    name: "OrderItem",
    props: {
      title: {
        required: true,
        type: String,
      },
      price: {
        type: Number,
      },
      isFree: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      formattedPrice() {
        if(this.price !== undefined) return (this.price / 100).toFixed(2);
      },
    }
  }
</script>
